import React from 'react';
import { useParams } from 'react-router-dom';
import DbtProjectDashboard from '../../components/dbt/DbtProjectDashboard';
import { FeatureGate } from '../../components/billing';

/**
 * DbtDashboardPage
 * Main dbt dashboard page showing project overview
 */
const DbtDashboardPage = () => {
  const { projectId } = useParams();

  return (
    <FeatureGate
      feature="dbt_enabled"
      upgradeMessage="View your dbt project dashboard with models, tests, and recent runs."
    >
      <div className="container mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold">dbt Project Dashboard</h1>
          <p className="text-base-content/70 mt-2">
            Overview of your dbt models, tests, and recent runs
          </p>
        </div>

        {projectId ? (
          <DbtProjectDashboard projectId={projectId} />
        ) : (
          <div className="alert alert-warning">
            <span>Please select a project to view the dashboard.</span>
          </div>
        )}
      </div>
    </FeatureGate>
  );
};

export default DbtDashboardPage;
